<template>
  <el-dialog
    :visible.sync="dialogSwitch"
    :close-on-click-modal="false"
    class="dialogBox"
    width="900px"
    :show-close="false"
    :modal-append-to-body="false">
    <svg class="closeIcon cursor" aria-hidden="true" @click="dialogSwitch = false">
      <use xlink:href="#icon-a-Property1shibai" />
    </svg>
    <h4 class="messageTitle">二维码</h4>
    <div class="QRCode-box">
      <div class="QRCode-preview">
        <h4 class="title">二维码预览</h4>
        <!-- <div ref="qrCode"></div> -->
        <vue-qr v-if="format!=3" :text="linkUrl" :logoSrc="imageUrl+'?cache'" :logoScale="0.2" :size="200" :margin="0" colorDark="#000" colorLight="#fff"></vue-qr>
        <vue-qr v-if="format==3" :text="linkUrl"  :size="200" :margin="0" colorDark="#000" colorLight="#fff"></vue-qr>

      </div>
      <div class="QRCode-download">
        <h3 class="title">图片格式</h3>
        <div>
          <el-radio-group v-model="format" >
            <el-radio-button label="1">jpg</el-radio-button>
            <el-radio-button label="2">png</el-radio-button>
            <el-radio-button label="3">SVG</el-radio-button>
          </el-radio-group>
          <div v-if="format == '1' || format == '2'">
            <h5 class="size">尺寸：</h5>
            <el-radio-group class="radio-box" v-model="size">
              <el-radio class="radio" label="1">300px*300px</el-radio>
              <el-radio class="radio" label="2">400px*400px</el-radio>
              <el-radio class="radio" label="3">500px*500px</el-radio>
              <el-radio class="radio" label="4">1000px*1000px</el-radio>
            </el-radio-group>
          </div>
          <div v-else>
            <p class="msg"> 矢量格式无需选择尺寸，且无法显示应用图标</p>
          </div>
        </div>
      </div>
    </div>
      <div class="foot-box">
        <el-button type="primary" @click="onDownload">下载</el-button>
      </div>
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr'
// import QRCode from "qrcodejs2";
// import AraleQRCode from 'arale-qrcode'
export default {
  name: "QRCode",
  components: {VueQr},
  data() {
    return {
      appDetail:{},
      // imageUrl:require("@/assets/img/head/logo.png"),
      imageUrl:'',
      dialogSwitch: false,
      qrnode:"",
      format: '1',
      size: '1',
      linkUrl:'',
      id:'',
      // appInfo:{
      //   title:'百度',
      //   url:'https://www.baidu.com/',
      //   // icon:'',//https://statres.quickapp.cn/quickapp/show/caseIcon/20230714/62fb5742e22ec.png
      // }
    };
  },

  methods: {
    // changeFormat(){
    //   if(this.format=='3'){
    //     this.imageUrl='';
    //   }else{
    //     this.imageUrl=this.appDetail.appIcon;
    //   }
    // },

    //获取应用信息
    // qrcode(){
    //   this.$apis.consoleSever.qrcode({
    //     id:5612757229241344,
    //     format:this.format,
    //     size:this.size,
    //   }).then(res=>{
    //     if (res.code == 0) {
    //       this.appDetail=res.data;
    //     }
    //   })
    // },
    open(appDetail,data) {
      this.dialogSwitch = true;
      this.$nextTick(()=>{
          this.appDetail=appDetail;
          this.imageUrl=this.appDetail.appIcon;
          this.id=data.id,
          this.linkUrl=data.linkUrl;
          // console.log(this.appDetail);
          // this.qrnode = new QRCode(document.createElement("div"), {
          //     text: this.appDetail.appName,
          //     width: 200, // 二维码宽度 （不支持100%）
          //     height: 200, // 二维码高度 （不支持100%）
          //     // colorDark: '#000', // 二维码颜色
          //     correctLevel: QRCode.CorrectLevel.H
          // });
          //   if(this.appDetail.appIcon) {
          //       let logo = new Image();
          //       logo.setAttribute("crossOrigin", "Anonymous");
          //       logo.src = this.appDetail.appIcon;
          //       logo.onload = () => {
          //         let qrImg = this.qrcode._el.getElementsByTagName('img')[0];
          //         let canvas = this.qrcode._el.getElementsByTagName('canvas')[0];
          //         this.qrcode._el.title = "";
          //         canvas.style.display = "inline-block";
          //         let ctx = canvas.getContext("2d");
          //         // 设置logo的大小为二维码图片缩小的3.7倍
          //         ctx.drawImage(logo, (200 - 200 / 3.7) / 2, (200 - 200 / 3.7) / 2, 200 / 3.7, 200 / 3.7);
          //         qrImg.src = canvas.toDataURL();
          //         qrImg.style.display = "none";
          //         this.$refs.qrCode.appendChild(this.qrcode._el);
          //       }
          //   }
        
      })
    },
    onDownload() {
        this.$apis.consoleSever.qrcode({
        id:this.id,
        format:this.format,
        size:this.size,
      }).then(res=>{
        if (res.code == 0) {
          // this.appDetail=res.data;
          let link = res.data.link;
          window.location.href = link;
        }
      })
      // let QRCode = new AraleQRCode({
      //   format: this.format.toLowerCase(),
      //   text: this.appInfo.url,
      //   size: this.size,
      //   image: this.appInfo.icon,
      //   imageSize: this.size/4,
      //   correctLevel: 1
      // });
      // if(this.format == 'SVG'){
      //   this.downloadSVG(QRCode)
      // }else{
      //   this.downloadImg(QRCode)
      // }
    },
    downloadSVG(QRCode) {
      // 创建一个隐藏的链接元素
      const link = document.createElement("a");
      link.style.display = "none";
      document.body.appendChild(link);
      // 将SVG内容转换为Blob对象
      const svgData = new XMLSerializer().serializeToString(QRCode);
      const blob = new Blob([svgData], { type: "image/svg+xml" });
      // 创建URL并设置链接元素的属性
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download =  this.appInfo.title;
      // 模拟点击链接进行下载
      link.click();
      // 清理URL和链接元素
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    },
    downloadImg(QRCode) {
        const MIME_TYPE = "image/"+this.format.toLowerCase();
        const imgURL = QRCode.toDataURL(MIME_TYPE);
        const link = document.createElement('a');
        link.download =  this.appInfo.title;
        link.href = imgURL;
        link.dataset.downloadurl = [MIME_TYPE, link.download, link.href].join(':');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
  }
  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 30px;
    height: 30px;
  }
  .messageTitle {
    position: relative;
    font-size: 32px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
  }
  .QRCode-box{
    display: flex;
    margin-top: 40px;
    padding: 20px 50px 20px 140px;
    .title{
      text-align: left;
      margin-bottom: 20px;
      color: rgba(18, 18, 18, 1);
      font-size: 28px;
    }
    .QRCode-preview{
      widows: 40%;
      margin-right: 100px;
    }
    .QRCode-download{
      flex: 1;
      text-align: left;
      .size{
        margin-top: 30px ;
      }
      .radio-box{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .radio{
          width: 50%;
          text-align: left;
          margin-top: 25px;
          margin-right: 0px;
        }
      }
      .msg{
        margin-top: 60px;
      }
    }
  }
  .foot-box{
    text-align: center;
    padding-bottom:20px;
  }
}
</style>
